/**
 * @fileoverview ESM mirror of ../getOwnApiPublicUrl.js.
 *
 * Drift between this file and the CJS source is caught by
 * `tests/esm/native-import.test.mjs`.
 *
 * @module @puffin-core/cross-app-policy/getOwnApiPublicUrl
 */

import { APP_REGISTRY } from './registry.js';

function getOwnApiPublicUrl(appKey, options = {}) {
  const envOverride = options.envOverride;
  if (typeof envOverride === 'string' && envOverride.length > 0) {
    return envOverride;
  }
  const entry = APP_REGISTRY[appKey];
  if (!entry) {
    throw new TypeError(
      `getOwnApiPublicUrl: unknown appKey "${appKey}". ` +
        `Known keys: ${Object.keys(APP_REGISTRY).join(', ')}.`,
    );
  }
  return `https://api.${entry.defaultDomain}`;
}

export { getOwnApiPublicUrl };
